var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row justify-end" },
    [
      _c(
        "vs-button",
        {
          staticClass: "mt-5 mr-5",
          attrs: {
            "data-cy": "cancel",
            color: "primary",
            disabled: _vm.saving
          },
          on: { click: _vm.back }
        },
        [_vm._v(" Cancelar ")]
      ),
      _c(
        "vs-button",
        {
          directives: [
            {
              name: "has-permission",
              rawName: "v-has-permission",
              value: "ED276",
              expression: "'ED276'"
            }
          ],
          staticClass: "mr-5 mt-5 btn btn-secondary",
          attrs: {
            "data-cy": "save-draft",
            size: "sm",
            disabled: _vm.saving || _vm.disabled
          },
          on: { click: _vm.saveDraft }
        },
        [
          _vm._v(" Guardar borrador "),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.saving,
                expression: "saving"
              }
            ],
            staticClass: "spinner-border spinner-border-sm text-primary"
          })
        ]
      ),
      _c(
        "vs-button",
        {
          staticClass: "mt-5 mr-5",
          attrs: {
            "data-cy": "preview",
            color: "warning",
            disabled: _vm.saving
          },
          on: { click: _vm.preview }
        },
        [
          _vm._v(" Previsualizar "),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.saving,
                expression: "saving"
              }
            ],
            staticClass: "spinner-border spinner-border-sm text-primary"
          })
        ]
      ),
      _c(
        "vs-button",
        {
          staticClass: "mt-5 mr-5",
          attrs: { "data-cy": "save", color: "success", disabled: _vm.saving },
          on: { click: _vm.save }
        },
        [
          _vm._v(" Crear "),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.saving,
                expression: "saving"
              }
            ],
            staticClass: "spinner-border spinner-border-sm text-primary"
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }